import { useEffect, useState } from 'react';
import { dispatcher } from 'dispatcher';

import { trackJackpotVisibility } from '@core/js/components/main/Games/trackingApi';

let observer: IntersectionObserver;
let visibleEntries: { isIntersecting?: boolean; target?: Element }[] = [];

const onChangeIntersectionObserver = (entries: IntersectionObserverEntry[]) => {
    visibleEntries = entries.reduce((acc, { isIntersecting, target }) => {
        return isIntersecting
            ? [...acc, { target }]
            : acc.filter(item => item.target !== target);
    }, visibleEntries);

    trackJackpotVisibility(visibleEntries);
};

export const useIsVisibleJackpot = (ref: HTMLDivElement | null) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!ref) {
            return;
        }

        const onChangeVisibility = (entries: IntersectionObserverEntry[]) => {
            setIsVisible(Boolean(entries.find((item) => item.target === ref)));
        };

        if (!observer) {
            observer = new IntersectionObserver(onChangeIntersectionObserver);
        }

        observer.observe(ref);
        dispatcher.listen('jackpot:visibility', onChangeVisibility);

        return () => {
            observer.unobserve(ref);
            dispatcher.removeListener('jackpot:visibility', onChangeVisibility);
        };
    }, [ref]);

    return isVisible;
};
